import { render } from "./reschedule-btn.vue?vue&type=template&id=33bf94a4"
import script from "./reschedule-btn.vue?vue&type=script&lang=js"
export * from "./reschedule-btn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__